export default __webpack_public_path__ + "img/tissue.4a845866.jpg";